import type { PropsWithChildren } from "react";

import {
  Box,
  BoxProps,
  StylesProvider,
  useMultiStyleConfig,
} from "@chakra-ui/react";

// Style props land on the Box after `__css`, so callers can override the theme's base
// wrapper style (e.g. white text on a dark card).
interface Props extends Omit<BoxProps, "children"> {
  size?: string;
  variant?: string;
  children: React.ReactNode;
}

const Wrapper = ({
  size,
  variant,
  children,
  ...props
}: PropsWithChildren<Props>) => {
  const styles = useMultiStyleConfig("Markdown", { size, variant });

  return (
    <Box __css={styles.wrapper} {...props}>
      <StylesProvider value={styles}>{children}</StylesProvider>
    </Box>
  );
};

export default Wrapper;
